import Vue from "vue";
import Vuex from "@src/_store/store";
import {globals} from "@src/utils/globals";
import {PlateServicesVehicleTokenRenewProcessNumber} from "@services/PlateServices.js";

export const helpers = {
    getParameterByName(name) {
        var match = RegExp("[?&]" + name + "=([^&]*)").exec(
            window.location.search
        );
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    },
    getVehicleAttribute(attributeID) {
        let value = null;
        if (Vuex.getters["vehicleIdentification/getState"].processNumber) {
            value = Vuex.getters["vehicleIdentification/getState"].data.find(
                (o) => o.attribID == attributeID
            );
        }
        return value;
    },
    getVehicleAttributeValue(attributeID) {
        let attrib = helpers.getVehicleAttribute(attributeID);
        if (attrib && attrib.value) {
            return attrib.value;
        }
        return "";
    },
    onlyVRMActive() {
        const modules = Vuex.getters["auth/getState"].modules;
        const filterByActive = modules.filter((m) => m.isActive);
        return (
            filterByActive &&
            filterByActive.length == 1 &&
            filterByActive[0].moduleId ==
                globals.MODULES.VEHICLE_IDENTIFICATION.ID
        );
    },
    getModuleConfigById(id) {
        for (const key in globals.MODULES) {
            if (globals.MODULES.hasOwnProperty(key)) {
                if (globals.MODULES[key].ID === id) {
                    let obj = {
                        route: globals.MODULES[key].ROUTE,
                        iconSidebar: globals.MODULES[key].ICON_SIDEBAR,
                        icon: globals.MODULES[key].ICON_DASHBOARD,
                    };

                    if (globals.MODULES[key].hasOwnProperty("ACTIVE")) {
                        obj.isActive = globals.MODULES[key].ACTIVE;
                    }

                    return obj;
                }
            }
        }
        return null;
    },
    async handleRenewProcessNumber(callback) {
        let vehicleState = Vuex.getters["vehicleIdentification/getState"];
        if (vehicleState.token) {
            let body = {
                token: vehicleState.token,
            };
            await PlateServicesVehicleTokenRenewProcessNumber(body)
                .then((response) => {
                    vehicleState.token = response.data.result;
                    Vuex.commit(
                        "vehicleIdentification/setVehicleIdentification",
                        vehicleState
                    );
                })
                .catch((error) => {
                    if (callback && vehicleState) callback();
                    console.error("error handleRenewProcessNumber", error);
                });
        }
    },
    async clearShoppingCart(callback) {
        Vuex.commit("loadings/setStateLoadingTemplate", true);
        let processNummber =
            Vuex.getters["vehicleIdentification/getState"].processNumber;
        Vuex.commit("budget/setCurrentProcessNumberByCar", processNummber);
        Vuex.commit("budget/setB2bClearShoppingCart");
        Vuex.commit("budget/setB2bClearShoppingCartToStep2");
        localStorage.removeItem("budgetB2b");

        await helpers.handleRenewProcessNumber(this.forceResolveVehicle);

        await Vue.nextTick();

        const shoppingCartCopy = {
            operations: [],
            parts: [],
        };
        const payloadBudgetStartedBy = {
            budgetId: null,
            budgetName: "",
        };
        const shoppingCartTotals = {
            operations: { totals: {} },
            parts: { totals: {} },
        };
        Vuex.commit("budget/setBudgetStartedBy", payloadBudgetStartedBy);
        Vuex.commit("budget/setShoppingCartCopy", shoppingCartCopy);
        Vuex.commit("budget/setShoppingCartTotalsClear", shoppingCartTotals);
        Vuex.commit(
            "activeReception/setActiveReceptionServicesAssociatedQuotationId",
            null
        );
        Vuex.commit("budget/setB2bCurrentStep", 1);
        localStorage.removeItem("@copyShoppingCart");
        localStorage.removeItem("@shoppingCartTotals");
        localStorage.removeItem("budgetB2b");
        Vuex.commit("budget/setClearBudgetSummary", {});
        Vuex.commit("budget/setB2bClearShoppingCart");
        Vuex.commit("loadings/setStateLoadingTemplate", false);

        await Vue.nextTick();

        if (callback) callback();
    },
    getModule(moduleId) {
        let modules = Vuex.getters["auth/getState"].modules;
        if (!modules) return false;
        return modules.find((o) => o.moduleId == moduleId);
    },
    isModuleActive(moduleId) {
        let module = helpers.getModule(moduleId);
        return module && module.isActive;
    },
    isModuleActiveAndVisible(moduleId) {
        let module = helpers.getModule(moduleId);
        return module && module.isActive && module.isVisible;
    },
};
